import styled from 'styled-components'

export const LinkGroupContainer = styled.div`
  display: flex;
  justify-content: space-around;
  min-width: 150px;
  font-size: 25px;

  a {
    color: #bebebe;
  }
`
